import { FC } from 'react'
import {
  Checkbox as InternalCheckbox,
  CheckboxChangeEvent,
  CheckboxProps,
} from './checkbox'
import {
  Group as CheckboxGroup,
  GroupProps as CheckboxGroupProps,
} from './group'

interface CheckboxType extends FC<CheckboxProps> {
  Group: typeof CheckboxGroup
}

const Checkbox = InternalCheckbox as CheckboxType
Checkbox.Group = CheckboxGroup

export { Checkbox }
export type { CheckboxProps, CheckboxGroupProps, CheckboxChangeEvent }
